<div class="wrapper-forgot-password-page">
  <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmitForgotPasswordForm()" novalidate class="content-forgot-password">
    <div class="back-btn" [routerLink]="PAGES_AND_PATHS.login.pagePath">
      <img src="../assets/icons/icon-arrow-left.svg" alt="">
    </div>
    <div class="wrapper-circle-gray-icon">
      <img src="../assets/icons/outline/icon-security.svg" alt="">
    </div>
    <div class="wrapper-header-forgot-password">
      <h1 *ngIf="!formSubmittedSuccess">{{'FORGOT_PASSWORD.dont_worry' | translate}}</h1>
      <h6 *ngIf="!formSubmittedSuccess">{{'FORGOT_PASSWORD.you_can_reset_your_password' | translate}}</h6>
      <h1 *ngIf="formSubmittedSuccess">{{'FORGOT_PASSWORD.check_your_inbox' | translate}}!</h1>
      <h6 *ngIf="formSubmittedSuccess">{{'FORGOT_PASSWORD.weve_sent_a_link' | translate}}.</h6>
    </div>
    <div *ngIf="!formSubmittedSuccess" class="wrapper-input" [ngClass]="{'error': forgotPasswordForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.' : formTriedToSubmit}">
      <span class="label-input">{{'FORGOT_PASSWORD.please_enter_your_registered_email_address' | translate}}</span>
      <div class="custom-input">
        <input formControlName="email" type="text" placeholder="{{'NEW_TEXT.enter_you_email_address' | translate}}">
      </div>
      <div *ngIf="forgotPasswordForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit" class="wrapper-error-message">
        <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
        <span>{{forgotPasswordForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit}}</span>
      </div>
    </div>
    <div *ngIf="formSubmittedSuccess" class="wrapper-input">
      <span class="label-input">{{'FORGOT_PASSWORD.if_your_email_is_registered_you_should_receive_a_link_to_redefine_your_password' | translate}}</span>
      <span class="label-input">{{'FORGOT_PASSWORD.if_you_dont_see_the_email_check_your_spam_folder' | translate}}</span>
    </div>
    <button *ngIf="!formSubmittedSuccess"  type="submit" class="custom-btn custom-btn--primary xs-mt-12">
      <span>{{'NEW_TEXT.reset_your_password' | translate}}</span>
      <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
    </button>
  </form>
</div>

